import TaseTipo from "./TaseTipo";

export default TaseTipo;